import { useEffect, useState } from "react";

import mainStore from "store/mainStore";
import childStore from "store/childStore";
import StdButton from "components/Buttons/StdButton";
import { CheckCircleIcon } from "components/Icons";
import proxy from "api/proxy";

function normalizeTags(raw) {
  if (!raw) return null;
  if (Array.isArray(raw)) {
    return raw.reduce((acc, item, i) => {
      if (typeof item === "string") {
        acc[i] = { name: item };
      } else if (item?.name) {
        acc[i] = item;
      }
      return acc;
    }, {});
  }
  return raw;
}

const ModalTags = (props) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState(null);
  const [product, setProduct] = useState(null);
  const [id, setId] = useState(null);

  useEffect(() => {
    const child = childStore.getState();
    setProduct(child.record?.product);
    setId(child.record?.id);
  }, []);

  useEffect(() => {
    async function fetchTags() {
      const productId = product?.id;
      if (!productId) return;

      const { data } = await proxy.search(
        "product.product",
        [["id", "=", productId]],
        ["tags.name"],
      );
      const rawTags = data?.[0]?.["tags."] ?? data?.[0]?.tags;
      setTags(normalizeTags(rawTags));
    }
    if (!product?.tags && !product?.template?.tags) {
      fetchTags();
    } else {
      setTags(normalizeTags(product?.tags || product?.template?.tags));
    }
  }, [product?.id]);

  const toggleTag = (key) => {
    setSelectedTags((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const handleAddTags = () => {
    const {
      store,
      record: recordWizard,
      updateRecord,
      updateStore,
    } = mainStore.getState();
    const _store = { ...store, lines: new Map(store.lines) };
    const _record = { ...recordWizard, lines: new Map(recordWizard.lines) };

    const selectedTagsNames = selectedTags
      .map((key) => (tags?.[key] ? tags[key].name : ""))
      .filter(Boolean)
      .join(", ");
    const createMap = _store.lines.get("create");

    if (createMap?.has(id)) {
      const line = { ...createMap.get(id), note: selectedTagsNames };
      createMap.set(id, line);
    }

    if (_record.lines.has(id)) {
      const line = { ..._record.lines.get(id), note: selectedTagsNames };
      _record.lines.set(id, line);
    }

    updateStore(_store);
    updateRecord(_record);
    const childState = childStore.getState();
    if (childState.record?.id === id) {
      childState.updateRecord({ ...childState.record, note: selectedTagsNames });
      childState.updateStore({ ...childState.store, note: selectedTagsNames });
    }
    props.onClose();
  };

  useEffect(() => {
    const { record: recordWizard } = mainStore.getState();
    const line = recordWizard.lines.get(id);

    if (line?.note) {
      setSelectedTags(
        line.note
          .split(",")
          .map((tagName) => tagName.trim())
          .filter(Boolean),
      );
    } else {
      setSelectedTags([]);
    }
  }, [id]);

  return (
    <div className="flex flex-col gap-4">
      {tags && Object.keys(tags).length > 0 ? (
        <>
          <div className="grid grid-cols-2 gap-4 py-5">
            {Object.entries(tags).map(([key, tag]) => (
              <div
                key={key}
                className={`w-full px-5 py-3 hover:scale-100 border cursor-pointer duration-100 transform rounded-lg transition-all flex items-center space-x-4 justify-between ${
                  selectedTags.includes(key)
                    ? "bg-green-400 border-green-600"
                    : "bg-green-100 border-green-200"
                }`}
                onClick={() => toggleTag(key)}
              >
                <span className="">{tag.name}</span>
                {selectedTags.includes(key) && (
                  <CheckCircleIcon
                    width={22}
                    className="fill-green-700 justify-self-center"
                  />
                )}
              </div>
            ))}
          </div>
          <div className="flex justify-center">
            <StdButton
              style="p-2 bg-blue-500 text-white rounded-lg w-full"
              onClick={handleAddTags}
              content={"sale.lines.add_tags"}
            />
          </div>
        </>
      ) : (
        <p className="text-center text-gray-400 py-5">Este producto no tiene etiquetas</p>
      )}
    </div>
  );
};

export default ModalTags;
